<template>
  <div>
    <el-table v-loading="loading" :data="dataList" :height="height">
      <el-table-column label="竞争对手" width="120" align="center" prop="competitor" />
      <el-table-column label="公司网址" width="100" align="center" prop="website" />
      <el-table-column label="所在城市" min-width="100" align="center" prop="areaName" />
      <el-table-column label="公司人数" width="100" align="center" prop="peopleNumber" />
      <el-table-column label="优势" min-width="120" align="center" :show-overflow-tooltip="true" prop="strengths" />
      <el-table-column label="劣势" min-width="120" align="center" :show-overflow-tooltip="true" prop="weaknesses" />
      <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="删除竞争对手" :visible.sync="visible" width="30%">
      <p>您已选中{{updateData.type}}角色</p>
      <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="120px">
        <el-form-item label="更改后联系人:" prop="contactId">
          <el-select v-model="updateData.contactId" placeholder="请选择更改后联系人" clearable style="width:100%">
            <el-option v-for="dict in contactList" :key="dict.id" :label="dict.name" :value="dict.id"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
    </el-dialog>
    <AddBusinessCompetitorDialog ref="addBusinessCompetitorDialogRef" @success="queryList"></AddBusinessCompetitorDialog>
  </div>
</template>

<script>

import {queryBusinessCompetitor, changeBusinessCompetitor} from "@/api/crm/business";
import AddBusinessCompetitorDialog from "@/views/crm/business/addBusinessCompetitorDialog";

export default {
  name: "BusinessCompetitorList",
  props: {
    businessId: {},
    height: {
      type: String,
      default () {
        return "250"
      }
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      dataList: [],
      contactList: [],
      updateData: {
        id: null,
        businessId: null,
        type: null,
        contactId: null
      },
      updateRules: {
        contactId: [
          {required: true, type: 'number', message: '请选择更改后联系人', trigger: 'change'}
        ]
      }
    };
  },
  created() {
    if (this.businessId) {
      this.queryList();
    }
  },
  components: {
    AddBusinessCompetitorDialog
  },
  watch: {
    businessId (val) {
      if (val) {
        this.queryList();
      } else {
        this.dataList = []
      }
    },
    visible (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    }
  },
  methods: {
    queryList () {
      this.loading = true;
      queryBusinessCompetitor({id: this.businessId}).then(response => {
        this.dataList = response.data;
        this.$emit('after-query', response.data || []);
        this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      })
    },
    handleDelete(row) {
      this.updateData = row;
      this.updateData.delFlag = 1;
      this.updateData.businessId = this.businessId
      this.$confirm('确认移除该竞争对手(' + row.competitor + ')吗？', '提示', {confirmButtonText: '确认'}).then(() => {
        const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
        changeBusinessCompetitor(this.updateData).then(response => {
          // 刷新页面
          this.queryList()
          this.refreshOperateLogList()
          this.msgSuccess("操作成功");
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {
      });
    },
    handleEdit(row) {
      this.$refs.addBusinessCompetitorDialogRef.open(this.businessId, row.id);
    },
    confirm () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          changeBusinessCompetitor(this.updateData).then(response => {
            this.queryList();
            this.$emit('after-change');
            this.visible = false;
            loading.close();
            this.msgSuccess("竞争对手更改成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
